import React from 'react'
import { useTheme } from '@mui/material/styles'

/**
 * withTheme HOC — replacement for the deprecated @mui/styles withTheme.
 * Injects `theme` prop into wrapped class components.
 */
const withTheme = (Component) => {
  const WithTheme = React.forwardRef((props, ref) => {
    const theme = useTheme()
    return <Component {...props} theme={theme} ref={ref} />
  })
  WithTheme.displayName = `WithTheme(${Component.displayName || Component.name || 'Component'})`
  return WithTheme
}

export default withTheme
